import React from 'react';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import { IButtonProps } from '../Button/Button';
import { Helmet } from 'react-helmet';

type IFixedButtonProps = Pick<IButtonProps, 'caption' | 'onClick' | 'className' | 'form'>

const FixedButton: React.FC<IFixedButtonProps> = ({ caption, onClick, className, form }) =>
    <div className="App__container-fixed-buttons">
        <PrimaryButton
            className={'App__fixed-button ' + (className || '')}
            caption={caption}
            onClick={onClick}
            form={form}
        />
        <Helmet>
            <style media="screen and (max-width: 24rem)">{'.footer { display: none; }'}</style>
        </Helmet>
    </div>

export default FixedButton;